var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import { Icon } from '../../icon/src';
export var DismissButton = function (_a) {
    var disabled = _a.disabled, dismissLabel = _a.dismissLabel, onDismiss = _a.onDismiss;
    var tokenAttributes = {
        tabIndex: -1,
        'override-focus': true
    };
    if (dismissLabel) {
        tokenAttributes['aria-label'] = dismissLabel;
    }
    if (!disabled) {
        tokenAttributes.onclick = onDismiss;
        tokenAttributes.tabIndex = 0;
    }
    return (AwsUi.__createElement("button", __assign({ type: "button", className: "awsui-token-dismiss" }, tokenAttributes),
        AwsUi.__createElement(Icon, { name: "close" })));
};
//# sourceMappingURL=dismiss-button.js.map